import * as React from 'react';

function SvgCreateStyle(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 14" {...props}>
      <path d="M14.689 6.56L8.296.546 7.867.142a.545.545 0 00-.734 0L.31 6.56a.966.966 0 00-.31.716c.007.548.491.986 1.074.986h.703v5.071h11.446V8.262h.718c.283 0 .55-.105.75-.293.2-.189.309-.44.309-.706a.963.963 0 00-.311-.703zm-6.262 5.652H6.573V9.036h1.854v3.176zm3.605-5.072v5.072H9.485v-3.55c0-.344-.296-.623-.661-.623H6.176c-.365 0-.661.279-.661.623v3.55H2.968V7.14H1.38l6.122-5.756.382.36 5.738 5.396h-1.59z" />
    </svg>
  );
}

export default SvgCreateStyle;
